/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-29 09:46:15
 * @LastEditors: changfeng
 * @LastEditTime: 2024-07-12 19:29:03
 */
import http from "@/api";

export const createSubscriptionOrder = (params: { planProductId: number }) => {
	return http.post("/plan/order/create", params);
};

export const cancelSubscriptionOrder = () => {
	return http.get("/plan/order/cancel");
};
/** 升级套餐 */
export const upgradeSubscriptionOrder = params => {
	return http.post("/plan/order/upgrade", params);
};

export const cancelPayment = params => {
	return http.post("/plan/payment/cancel", params);
};

export const fetchProductList = () => {
	return http.get("/plan/product/list");
};

export const fetchBillingHistory = () => {
	return http.get("/plan/payment/billing");
};

/** 获取创建订阅时用户代金券总额 */
export const fetchUseCouponAmount = params => {
	return http.post("/plan/order/create/amount", params);
};

/** 获取升级订阅时用户代金券总额  */
export const fetchUpgradePlanUseAmount = params => {
	return http.get("/plan/order/upgrade/amount", params);
};

/** 续订代金券金额回显 */
export const fetchRenewPlanUseAmount = params => {
	return http.get("/plan/order/renew/amount", params);
};

/** 使用代金券续订 */

export const fetchRenewPlanUseCoupon = params => {
	return http.post("/plan/order/renew/coupon", params);
};

/** 降级套餐 */
export const fetchDownGrade = () => {
	return http.post("/plan/order/downgrade");
};

/** 重新激活订阅 */
export const reactivate = () => {
	return http.post("/plan/order/renew/active");
}
